import { gql } from 'graphql-tag'

/**
 * Returns the current user's settings as a `{ key: value }` JSON map.
 * Optionally filter by `keyPrefix` or a list of `keys`.
 * Settings the user has never set are omitted (frontend merges with its own defaults).
 */
export const MY_USER_SETTINGS_QUERY = gql`
  query MyUserSettings($keyPrefix: String, $keys: [String!]) {
    myUserSettings(keyPrefix: $keyPrefix, keys: $keys)
  }
`

/**
 * Admin-only: returns settings for an arbitrary user. Used by the
 * "edit user settings" modal in /admin/users.
 */
export const USER_SETTINGS_QUERY = gql`
  query UserSettingsFor($userId: ID!, $keyPrefix: String, $keys: [String!]) {
    userSettingsFor(userId: $userId, keyPrefix: $keyPrefix, keys: $keys)
  }
`
